"use client";
import React from "react";
import Block from "./webflow_modules/Basic/components/Block";
import Link from "./webflow_modules/Basic/components/Link";

export function NavSubMarketListLink({
  link,
  showSpacer = true,
  text = "market",
}) {
  return (
    <Block className={"nav-sub-market-list-link-container-copy"} tag={"div"}>
      <Link
        button={false}
        className={"nav-sub-market-list-link"}
        options={link}
      >
        {text}
      </Link>
      {showSpacer ? (
        <Block className={"nav-sub-market-list-spacer"} tag={"div"} />
      ) : null}
    </Block>
  );
}
